import Swal from "sweetalert2";

/**
 * Retorna el HTML del mensaje de compatibilidad de dispositivos TV
 * Reutilizable en múltiples componentes
 */
export const getTvCompatibilityMessage = () => {
  return `
  <div style="background:#f8eaea;border:1px solid #d47f7f;border-radius:10px;padding:14px 16px;text-align:justify;margin-bottom:14px;">
  <p style="margin:0 0 6px 0;font-weight:700;color:#8f2222;font-size:17px;text-align:justify;">
  EMTV+ es un servicio de streaming autogestionado
  </p>
  <p style="margin:0 0 6px;color:#a33434;font-size:15px;line-height:1.35;text-align:justify;">
  No incluye dispositivos físicos como decodificadores, TV Box u otros equipos. Antes de comprar verifica la compatibilidad de tus dispositivos y que se encuentren actualizados.
  </p>

  <p style="margin:0;color:#a33434;font-size:15px;line-height:1.35;text-align:justify;">
  La creación de la solicitud no garantiza acceso si tu equipo no cumple los requisitos.
  </p>
  </div>
  <div style="display:flex;justify-content:center;align-items:center;gap:10px;margin-bottom:12px;">
    <p style="margin:0;font-size:18px;font-weight:700;color:#3f3f3f;">Compatibilidad de dispositivos</p>
  </div>

    <div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-bottom:14px;text-align:left;">
      <div style="background:#f9f6ff;border:1px solid #e6dbff;border-radius:12px;padding:12px;">
        <p style="margin:0 0 8px 0;font-weight:700;color:#4a1272;">Smart TV</p>
        <ul style="margin:0;padding-left:22px;list-style-type:disc;color:#555;line-height:1.45;font-size:14px;">
          <li>LG (webOS)</li>
          <li>Android TV / Google TV</li>
        </ul>
      </div>
      <div style="background:#f9f6ff;border:1px solid #e6dbff;border-radius:12px;padding:12px;">
        <p style="margin:0 0 8px 0;font-weight:700;color:#4a1272;">Dispositivos móviles</p>
        <ul style="margin:0;padding-left:22px;list-style-type:disc;color:#555;line-height:1.45;font-size:14px;">
          <li>Android 8.0 o superior</li>
          <li>iOS 14 o superior</li>
        </ul>
      </div>
      <div style="background:#f9f6ff;border:1px solid #e6dbff;border-radius:12px;padding:12px;">
        <p style="margin:0 0 8px 0;font-weight:700;color:#4a1272;">Streaming devices</p>
        <ul style="margin:0;padding-left:22px;list-style-type:disc;color:#555;line-height:1.45;font-size:14px;">
          <li>Amazon Fire TV Stick</li>
          <li>Roku</li>
          <li>Chromecast con Google TV</li>
        </ul>
      </div>
      <div style="background:#f9f6ff;border:1px solid #e6dbff;border-radius:12px;padding:12px;">
        <p style="margin:0 0 8px 0;font-weight:700;color:#4a1272;">Navegadores web</p>
        <ul style="margin:0;padding-left:22px;list-style-type:disc;color:#555;line-height:1.45;font-size:14px;">
          <li>Google Chrome</li>
          <li>Microsoft Edge</li>
          <li>Mozilla Firefox</li>
          <li>Safari</li>
        </ul>
      </div>
    </div>
    <p style="margin:0;font-size:20px;color:#444;">¿Quieres el paquete seleccionado?</p>
  `;
};

/**
 * Muestra primero el modal de compatibilidad y luego ejecuta el callback si el usuario confirma
 * @param {string} planName - Nombre del plan de TV
 * @param {function} onConfirm - Función a ejecutar cuando el usuario confirma compatible
 */
export const showTvCompatibilityModal = (planName, onConfirm) => {
  Swal.fire({
    title: planName,
    html: getTvCompatibilityMessage(),
    confirmButtonColor: "#528711",
    confirmButtonText: "Si, Continuar",
    cancelButtonText: "Cancelar",
    cancelButtonColor: '#6c757d',
    showCancelButton: true,
    reverseButtons: true,
    customClass: { popup: 'tv-compat-popup' },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};
